import React, { useEffect } from 'react';
import { useActivation } from '@context/MobileOne';
import { useA11y } from '@context/Utils/A11y';
import { EmailVerification } from './EmailVerification';
import { EmailVerificationCode } from './EmailVerificationCode';
import { EmailVerificationSuccess } from './EmailVerificationSuccess';
import { EmailVerificationCodeSuccess } from './EmailVerificationCodeSuccess';
import { EmailVerificationResendSuccess } from './EmailVerificationResendSuccess';
import { Meta } from '@core/Meta';
import { keyValueValidation } from '@utils/globalConstant';
import { useTitle } from '@context/Utils/Title';

export function ActivationStep0() {
  // Context
  const { step0SubStep, setShowActivationFooter } = useActivation();
  const { tA11yTranslate, getGlobalMetaTitles } = useA11y();
  const { announceTitle } = useTitle();

  // META: handle page titles
  const { globalPageTitle, globalSuccessPageTitle } = getGlobalMetaTitles();
  const activationEmailVerificationPageTitle = tA11yTranslate(
    'ek_global_meta_title_email_verification'
  ).content;
  const emailConfirmPageTitle = tA11yTranslate(
    'ek_global_meta_title_email_confirm'
  ).content;


  const isTranslationReady = keyValueValidation(
    activationEmailVerificationPageTitle,
    'ek_global_meta_title_email_verification'
  );

  // Determine the page title based on the current substep
  const getPageTitle = () => {
    switch (step0SubStep) {
      case 0:
        return `${globalPageTitle} - ${activationEmailVerificationPageTitle}`;
      case 1:
        return `${globalPageTitle} - ${globalSuccessPageTitle}`;
      case 2:
        return `${globalPageTitle} - ${emailConfirmPageTitle}`;
      case 3:
        return `${globalPageTitle} - ${globalSuccessPageTitle}`;
      case 4:
        return `${globalPageTitle} - ${globalSuccessPageTitle}`;
      default:
        return `${globalPageTitle} - ${activationEmailVerificationPageTitle}`;
    }
  };

  // Hooks
  useEffect(() => {
    // Hide footer for below screens
    // 0.1.1.2.2 - registration step 0 - mail success
    // 0.1.1.2.5 - registration step 0 - 2fa success
    if (step0SubStep === 1 || step0SubStep === 3) {
      setShowActivationFooter(false);
    } else {
      setShowActivationFooter(true);
    }
  }, [step0SubStep]);

  useEffect(() => {
    const pageTitle = `${getPageTitle()}`;
    announceTitle(pageTitle);
  }, [step0SubStep, announceTitle]); // Re-run when substep changes

  const renderStep0SubSteps = (subStep) => {
    switch (subStep) {
      case 0:
        return <EmailVerification />;
      case 1:
        return <EmailVerificationSuccess />;
      case 2:
        return <EmailVerificationCode />;
      case 3:
        return <EmailVerificationCodeSuccess />;
      case 4:
        return <EmailVerificationResendSuccess />;
      default:
        return <EmailVerification />;
    }
  };

  return (
    <>
      <Meta title={getPageTitle()} key={`meta-key-${step0SubStep}`} />
      {renderStep0SubSteps(step0SubStep)}
    </>
  );
}

export default ActivationStep0;
